<template>
  <v-card
    v-touch="$ftTap(() => $emit('click:avatar', member))"
    height="100%"
    class="pa-3"
    style="border-radius: 0px;"
  >
    <v-card-title class="px-2 py-1">
      <v-list-item-avatar 
        :style="`border-radius: 50%; ${!!member.id ? 'cursor: pointer;' : ''}`"
        @click="$emit('click:avatar', member)"
      >
        <img 
          v-if="!!reservee.memberPhoto"
          :src="reservee.memberPhoto"
        >
        <v-icon v-else>
          {{ reservee.icon }}
        </v-icon>
      </v-list-item-avatar>
      <div>
        <v-card-text class="pa-0 subheading">
          {{ reservee.name }}
        </v-card-text>
        <v-card-text
          v-if="member.memNum || sameMonthDayInt(reservation.dateTime, member.birth) || (reservation.guests && reservation.guests.length)"
          class="pa-0 caption"
        >
          <v-icon
            v-if="sameMonthDayInt(reservation.dateTime, member.birth)"
            small
          >
            mdi-cake-variant
          </v-icon>
          <span v-if="member.memNum">{{ `${member.memNum} (${member.mType})` }}</span>
          <span v-if="reservee.guests && reservee.guests.length">{{ `+ ${reservee.guests.length} Guest` }}</span>
        </v-card-text>
      </div>
    </v-card-title>
    <v-card-text class="py-0 px-1 ft-chip-gap">
      <v-chip
        v-if="!!member.allergyInformation"
        :color="$ftStyle.reservation.allergyColor"
        class="mb-1 ft-expand-chip"
        text-color="white"
      >
        <v-icon
          left
          class="mr-1 pl-1"
        >
          {{ $ftStyle.reservation.allergyIcon }}
        </v-icon>
        <span>{{ member.allergyInformation }}</span>
      </v-chip>
      <v-chip
        v-if="member.foodPreference"
        :color="$ftStyle.reservation.foodPreferenceColor"
        class="mb-1 ft-expand-chip"
        text-color="white"
      >
        <v-icon
          left
          class="mr-1 pl-1"
        >
          mdi-silverware
        </v-icon>
        <span>{{ member.foodPreference }}</span>
      </v-chip>
      <v-chip
        v-if="member.drinkPreference"
        :color="$ftStyle.reservation.drinkPreferenceColor"
        class="mb-1 ft-expand-chip"
        text-color="white"
      >
        <v-icon
          left
          class="mr-1 pl-1"
        >
          mdi-glass-cocktail
        </v-icon>
        <span>{{ member.drinkPreference }}</span>
      </v-chip>
    </v-card-text>
    <v-card-text
      v-if="member.diningSpecialRequests"
      class="pa-2"
    >
      {{ member.diningSpecialRequests }}
    </v-card-text>
    <slot name="expanded-guests" />
  </v-card>
</template>

<script>
import moment from 'moment'
import touchHelpers from '@/ft-vue-core/mixins/touchHelpers'
export default {
  name: 'ReserveeCard',
  mixins: [touchHelpers],
  props: {
    reservee: {
      type: Object,
      default () {return {}}
    },
    reservation: {
      type: Object,
      default () {return {}}
    }
  },
  data () {
    return {tapActive: false}
  },
  computed: {
    member () {
      return this.reservee.member || {}
    }
  },
  methods: {
    sameMonthDayInt (stringDate, intDate) {
      return moment(stringDate).format('MMDD') === (intDate + '').slice(-4)
    },
    startTap () {
      this.tapActive = true
      setTimeout(() => this.tapActive = false, 200)
    },
    endTap (callback) {
      if (this.tapActive) this.runLast?.(callback)
    },
    runLast: (callback, ...inputs) => setTimeout(() => callback?.(...inputs))
  }
}
</script>